<div class="card card-list-bg" *ngIf="isLoading">
    <div class="card-header list-header d-flex justify-content-between">
        <h5 class="loading"><span class="mdi mdi-download" aria-hidden></span>Processing your request</h5>
    </div>
    <div class="card-body">
        <div class="text-center m-5 p-5">
            <div>
                <img src="{{loader}}" alt="IPOSPAYS LOADER" width="120" />
                <h5 class="mt-2" *ngIf="!backgroundMode">{{body}}</h5>
                <p *ngIf="backgroundMode" class="mt-2 alert alert-info mb-0">{{body}}</p>
                <ng-container *ngIf="!backgroundMode && timerData?.enableTimerContent">
                    <p class="mt-2 alert alert-warning" id="timerData">Downloading <b>{{timerData?.totalNoOfRows?.toLocaleString()}}</b> records,</p>
                </ng-container>
            </div>
        </div>
    </div>
</div>